module.exports = __webpack_public_path__ + "static/media/wordstat.84d19ee6.ico";